module.exports = __webpack_public_path__ + "static/media/whats_new_icon.aec58d6d.svg";